import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'next-themes';
import App from './App';
import './index.css';
import './nightops/motion.css';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/sonner';
window.__BUILD = '2026-03-23';

function render() {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem={false}
        disableTransitionOnChange
        themes={['dark', 'light']}
      >
        <TooltipProvider delayDuration={150}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </TooltipProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
}

// DEV-ONLY visual preview harness (dynamically imported so it is tree-shaken
// from production). Seeds a fake admin + mocks the API so the authenticated
// pages render locally with proposal-shaped data. Activate with `?__preview=1`.
async function bootstrap() {
  if (import.meta.env.DEV) {
    try {
      const { previewActive, installPreviewMocks } = await import('./dev/previewMocks');
      if (previewActive()) installPreviewMocks();
    } catch { /* preview harness is best-effort; never block real render */ }
  }
  render();
}

bootstrap();
